export const steps = [
  {
    id: "second",
    attachTo: {
      element: ".third-step",
      on: "top",
    },
    title: "Welcome to NeoLearn-Pathways!",
    text: ["Learn from structured resources & achieve your career goal"],
    buttons: [
      {
        classes: "shepherd-button-secondary",
        text: "Exit",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    when: {
      show: () => {
        console.log("show stepp");
      },
      hide: () => {
        console.log("complete step");
      },
    },
    highlightClass: "highlight",

    showCancelLink: false,
    scrollTo: true,
    modalOverlayOpeningPadding: 4,
    useModalOverlay: false,
    canClickTarget: false,
  },
  {
    id: "intro",
    attachTo: {
      element: ".second-step",
      on: "top",
    },
    attachTo: { element: ".curator-details", on: "right" },
    scrollTo: true,
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        setTimeout(function () {
          window.scrollTo(0, 0);
          resolve();
        }, 500);
      });
    },
    buttons: [
      {
        classes: "shepherd-button-secondary",
        text: "Exit",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "custom-class-name-1 custom-class-name-2",
    highlightClass: "highlight",
    showCancelLink: true,
    title: "NeoLearn-Pathway!",
    text: [`Connect with the mentor`],
    when: {
      show: () => {
        console.log("show step");
      },
      hide: () => {
        console.log("hide step");
      },
    },
  },

  {
    id: "third",
    attachTo: {
      element: ".second-step",
      on: "top",
    },
    attachTo: { element: ".pathway-left", on: "bottom" },
    scrollTo: true,
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        setTimeout(function () {
          window.scrollTo(0, 0);
          resolve();
        }, 500);
      });
    },
    buttons: [
      {
        classes: "shepherd-button-secondary",
        text: "Exit",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "custom-class-name-1 custom-class-name-2",
    highlightClass: "highlight",
    showCancelLink: true,
    title: "Neo-Learn-Pathway!",
    text: [`Follow the pathway in the structured manner`],
    when: {
      show: () => {
        console.log("show step");
      },
      hide: () => {
        console.log("hide step");
      },
    },
  },
  {
    id: "fourth",
    attachTo: {
      element: ".second-step",
      on: "top",
    },
    attachTo: { element: ".signup-container", on: "bottom" },
    scrollTo: true,
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        setTimeout(function () {
          window.scrollTo(0, 0);
          resolve();
        }, 500);
      });
    },
    buttons: [
      {
        classes: "shepherd-button-secondary",
        text: "Exit",
        type: "cancel",
      },
      {
        classes: "shepherd-button-primary",
        text: "Back",
        type: "back",
      },
      {
        classes: "shepherd-button-primary",
        text: "Next",
        type: "next",
      },
    ],
    classes: "custom-class-name-1 custom-class-name-2",
    highlightClass: "highlight",
    showCancelLink: true,
    title: "NeoLearn-Pathway!",
    text: [`Signup to get instance updates from us!`],
    when: {
      show: () => {
        console.log("show step");
      },
      hide: () => {
        console.log("hide step");
      },
    },
  },
];
